import { LiveScansTable } from '../components/LiveScansTable';

/**
 * Ads Live Jobs page — single panel showing the in-flight ads jobs.
 *
 * Mirrors `web/src/interior/pages/LiveScansPage.tsx` minus the batch
 * panel (the ads service has no batch concept). The
 * :class:`LiveScansTable` self-manages 3-second polling.
 */
export function AdsLiveScansPage() {
  return (
    <div className="space-y-6">
      <LiveScansTable />
    </div>
  );
}
